const initMultiColumnSliders = () => {
  const sliderContainers = document.querySelectorAll('.multicolumn-mobile-slider');
  const sliders = [];

  const initializeSlider = (container) => {

    const sliderWrapper = container.querySelector('.multicolumn-slider-wrapper');
    const slides = container.querySelectorAll('.multicolumn-slider-slide');

    if (sliderWrapper && slides) {
      sliderWrapper.classList.add('swiper-wrapper');
      slides.forEach(slide => slide.classList.add('swiper-slide'));

      return new Swiper(container, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        autoHeight: true,
        autoplay: container.dataset.autoplaySpeed === undefined ? false : {delay: parseInt(container.dataset.autoplaySpeed)},
        pagination: {
          el: ".swiper-dots",
          clickable: true,
          bulletClass: "swiper-dot",
          bulletActiveClass: "swiper-dot-active"
        }
      });
    }
    return null;
  };

  const destroySlider = (container, slider) => {
    if (slider) {
      slider.destroy(true, true);


      const sliderWrapper = container.querySelector('.multicolumn-slider-wrapper');
      const slides = container.querySelectorAll('.multicolumn-slider-slide');

      if (sliderWrapper) {
        sliderWrapper.classList.remove('swiper-wrapper');
      }
      if (slides) {
        slides.forEach(slide => slide.classList.remove('swiper-slide'));
      }
    }
  };

  const handleResize = () => {
    const isMobile = window.innerWidth < 768;

    sliderContainers.forEach((container, index) => {
      if (isMobile) {
        if (!sliders[index]) {
          sliders[index] = initializeSlider(container);
        }
      } else {
        if (sliders[index]) {
          destroySlider(container, sliders[index]);
          sliders[index] = null;
        }
      }
    });
  };


  handleResize();


  window.addEventListener('resize', handleResize);
};

document.addEventListener('DOMContentLoaded', initMultiColumnSliders);
